import { inject, Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';
import { FEATURE_NAME } from './access-log-dialog.constant';
import { DomainBaseActions } from '@vshosting/cdn/core';
import { map } from 'rxjs';
import { onVshcDialogClose } from '@vshosting/core';

@Injectable()
export class AccessLogDialogEffect {
  // # Deps
  #actions$ = inject(Actions);

  onDialogCloseCleanup$ = createEffect(() => this.#actions$.pipe(
    onVshcDialogClose(FEATURE_NAME),
    map(() => DomainBaseActions.domainAccessLogReset())
  ));

}
